import { toFormat, fromFormat, toShortYearInterval, getNow, toISODate } from './date';

const DatesService = { toFormat, fromFormat, toShortYearInterval, getNow, toISODate };

export default DatesService;
